/**
 * StepNextButton — Full-width gradient CTA for advancing wizard steps.
 * 48px height, pill radius, gradient teal when enabled.
 */

import { T } from '@/styles/tokens';

interface StepNextButtonProps {
  label: string;
  onPress: () => void;
  disabled: boolean;
}

export function StepNextButton({ label, onPress, disabled }: StepNextButtonProps) {
  return (
    <button
      onClick={onPress}
      disabled={disabled}
      style={{
        width: '100%',
        height: 48,
        borderRadius: 24,
        border: 'none',
        background: disabled
          ? T.border
          : `linear-gradient(135deg, ${T.primary}, ${T.primaryDark})`,
        color: disabled ? T.charcoal300 : T.white,
        fontSize: 15,
        fontWeight: 700,
        fontFamily: T.fontFamily,
        letterSpacing: '-0.01em',
        cursor: disabled ? 'default' : 'pointer',
        boxShadow: disabled ? 'none' : `0 4px 14px ${T.primary}33`,
        transition: 'all 0.2s ease',
        marginTop: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
      }}
    >
      {label}
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
